module.exports = __webpack_public_path__ + "static/img/kebao.8e3ce33a.png";